import React, { useCallback, useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { URLRoutes } from '../config';
import { useDispatch, useSelector } from 'react-redux';
import { setBtnSmallVmThunk, setBtnVwThunk } from '../store/drawerMenu';

export const ReservationSecurity = () => {
    const dispatch = useDispatch();
    const { originalReservation } = useSelector(store => store.reservation);

    React.useEffect(() => {
        dispatch( setBtnSmallVmThunk(true) );
        dispatch( setBtnVwThunk(false) );
    }, []);

    if (!originalReservation) {
        return <Navigate to={URLRoutes.searchRezHomePage()} replace />
    }

  return <Outlet />
}
